import React from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Modal,
  Dimensions,
} from "react-native";
import { FontFamilies } from "@/constants/Typography";
import { Ionicons } from "@expo/vector-icons";
import { ActionButton } from "@/components/ActionButton";

interface UnclaimedMoneyPopupProps {
  visible: boolean;
  onClose: () => void;
  onFileClaim: () => void;
  data?: {
    businessName: string;
    amount: string;
    maxAmount: string;
    minAmount: string;
    heldInState: string;
    ownerName: string;
  };
}

const { width } = Dimensions.get("window");

const UnclaimedMoneyPopup: React.FC<UnclaimedMoneyPopupProps> = ({
  visible,
  onClose,
  onFileClaim,
  data,
}) => {
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.modal}>
          {/* Close Button */}
          <TouchableOpacity style={styles.closeButton} onPress={onClose}>
            <Ionicons name="close" size={24} color="#666" />
          </TouchableOpacity>

          {/* Main Title */}
          <Text style={styles.title}>
            Claim your ${data?.amount || data?.maxAmount} check from{" "}
            {data?.businessName}
          </Text>

          {/* Description */}
          <Text style={styles.description}>
            You have an unclaimed check under your name. Sparrow will file an
            unclaimed money claim with the State of {data?.heldInState}.
          </Text>

          {/* Action Buttons */}
          <View style={styles.buttonContainer}>
            <ActionButton title="File claim" onPress={onFileClaim} />

            <ActionButton title="Cancel" onPress={onClose} type="hide" />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  modal: {
    backgroundColor: "white",
    borderRadius: 16,
    padding: 24,
    width: width - 40,
    maxWidth: 400,
    alignItems: "center",
    paddingTop: 40,
  },
  closeButton: {
    position: "absolute",
    top: 16,
    right: 16,
    zIndex: 1,
  },
  title: {
    fontSize: 20,
    fontFamily: FontFamilies.InterTight.Bold,
    color: "#111",
    textAlign: "center",
    marginBottom: 12,
    lineHeight: 28,
  },
  description: {
    fontSize: 14,
    fontFamily: FontFamilies.Inter.Regular,
    color: "#666",
    textAlign: "center",
    marginBottom: 24,
    lineHeight: 20,
  },
  buttonContainer: {
    width: "100%",
    gap: 12,
  },
});

export default UnclaimedMoneyPopup;
